import { createSlice } from "@reduxjs/toolkit";
import { admissionRrequirments } from "../../../types/admission_requirement";

export const admissionsRrequirments = createSlice({
  name: "admission_requirements",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: admissionRrequirments;
      }[],
      data: [] as admissionRrequirments,
    },
  },
  reducers: {
    update_admission_requirements: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_addmission_requirement: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_addmission_requirement: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_addmission_requirement: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_admission_requirements: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_admission_requirements,
  add_addmission_requirement,
  addToPaginationHistory,
  remove_addmission_requirement,
  replace_addmission_requirement,
  clear_admission_requirements,
} = admissionsRrequirments.actions;

export default admissionsRrequirments.reducer;
